const getReferrer = () => window.document.referrer || window?.frames?.top?.document.referrer || '';

export default getReferrer;
